import { render, staticRenderFns } from "./projectFlow.vue?vue&type=template&id=4372bc09&scoped=true&"
import script from "./projectFlow.vue?vue&type=script&lang=js&"
export * from "./projectFlow.vue?vue&type=script&lang=js&"
import style0 from "./projectFlow.vue?vue&type=style&index=0&id=4372bc09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372bc09",
  null
  
)

export default component.exports